var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowseJob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.165039,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#DBEAFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4985 33.3335C30.0711 34.099 30.8017 34.7324 31.6406 35.1907C32.4795 35.649 33.4072 35.9216 34.3607 35.9899C35.3143 36.0582 36.2713 35.9206 37.167 35.5865C38.0627 35.2524 38.876 34.7295 39.5519 34.0535L43.5519 30.0535C44.7663 28.7961 45.4382 27.1121 45.423 25.3641C45.4078 23.6161 44.7067 21.944 43.4707 20.708C42.2346 19.4719 40.5625 18.7708 38.8145 18.7556C37.0666 18.7404 35.3826 19.4124 34.1252 20.6268L31.8319 22.9068",
    stroke: "#2563EB",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8315 30.6666C34.2589 29.9011 33.5283 29.2677 32.6894 28.8094C31.8505 28.351 30.9228 28.0785 29.9693 28.0102C29.0158 27.9419 28.0587 28.0795 27.163 28.4136C26.2673 28.7477 25.454 29.2705 24.7782 29.9466L20.7782 33.9466C19.5638 35.204 18.8918 36.888 18.907 38.636C18.9222 40.384 19.6233 42.056 20.8594 43.2921C22.0954 44.5282 23.7675 45.2293 25.5155 45.2445C27.2635 45.2597 28.9475 44.5877 30.2048 43.3733L32.4848 41.0933",
    stroke: "#2563EB",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseJob);
export default __webpack_public_path__ + "static/media/browse-job.6f0dfc6212852a3e39f95e3e19d6266e.svg";
export { ForwardRef as ReactComponent };